import { TreatmentCalculator } from './TreatmentCalculator';

import { LineEntry } from '../../types';
import { LineEntryForm } from '../../types/treatment';

export class NotApplicableTreatmentCalculator extends TreatmentCalculator {
  constructor() {
    super();
  }

  static getTaxRate() {
    return 0;
  }

  static calculateLineItemsAndTotals({ lineItems }: { lineItems: LineEntryForm[] | LineEntry[] }) {
    return super.calculateLineItemsAndTotals({
      lineItems,
      strategy: { getTaxRate: this.getTaxRate },
    });
  }
}
